import {Button} from '@/components/ui/button/Button'
import {AlertCircleIcon, CheckCircleIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {
    StyledActivityReportDialogFooter,
    StyledActivityReportResultBody,
    StyledActivityReportResultIcon,
    StyledActivityReportResultSubtitle,
    StyledActivityReportResultTitle
} from './style'

type ActivityReportResultStepProps = {
    variant: 'error' | 'success'
    title: string
    subtitle: string
    onClose: () => void
}

export const ActivityReportResultStep = ({variant, title, subtitle, onClose}: ActivityReportResultStepProps) => {
    const {t} = useTranslation()

    return (
        <>
            <StyledActivityReportResultBody>
                <StyledActivityReportResultIcon $variant={variant}>
                    {variant === 'success' ? <CheckCircleIcon size={48} /> : <AlertCircleIcon size={48} />}
                </StyledActivityReportResultIcon>
                <StyledActivityReportResultTitle>{title}</StyledActivityReportResultTitle>
                <StyledActivityReportResultSubtitle>{subtitle}</StyledActivityReportResultSubtitle>
            </StyledActivityReportResultBody>
            <StyledActivityReportDialogFooter>
                <Button variant="primaryNeutral" onClick={onClose}>
                    {t('commons:close')}
                </Button>
            </StyledActivityReportDialogFooter>
        </>
    )
}
